const WizardEnum = {
    LocalData: 'LocalData',
    LocalCalls: 'LocalCalls',
    LocalIncomingCalls: 'LocalIncomingCalls',
    LocalOutgoingCalls: 'LocalOutgoingCalls',
    LocalMabal: 'LocalMabal',
  };

  export default WizardEnum;
